import "core-js/modules/es.array.for-each";
import "core-js/modules/web.dom-collections.for-each";

/*
 Copyright (c) 2017 Wells Fargo. 455 Market St., San Francisco, CA 94105 All rights reserved.

 This software is the confidential and proprietary information of Wells Fargo
 bank. ('Confidential Information'). You shall not disclose such Confidential
 Information and shall use it only in accordance with the terms of the license
 agreement you entered into with WellsFargo.

 Author: Thomas Barry

 Note: These tests rely on the following markup defined in /jest/jest-setup-file.js:
 <div id="root" data-app-container=""><div data-page-container=""></div></div>
 */
var containers = {};

var getElements = function getElements(name) {
  return document.querySelector("[".concat(name, "]"));
};

export var enableAriaAppHider = function enableAriaAppHider() {
  var containerNames = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
  containerNames.forEach(function (name) {
    if (containers.hasOwnProperty(name)) {
      containers[name].count++;
    } else {
      containers[name] = {
        count: 1
      };
    }

    getElements(name).setAttribute('aria-hidden', 'true');
  });
};
export var disableAriaAppHider = function disableAriaAppHider() {
  var containerNames = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
  containerNames.forEach(function (name) {
    containers[name].count--;

    if (containers[name].count === 0) {
      getElements(name).removeAttribute('aria-hidden');
    }
  });
};